export default __webpack_public_path__ + "static/media/crc.a8d77ec6.webp";